import {
  createIntegrationsQuickbooks,
  createIntegrationsQuickbooksAccountAssets,
  createIntegrationsQuickbooksAccountExpenses,
  createIntegrationsQuickbooksAccountLiabilities,
  createIntegrationsQuickbooksAccountRevenues,
  createIntegrationsQuickbooksCustomers,
  createIntegrationsQuickbooksItems,
  createIntegrationsQuickbooksVendors,
  deleteIntegrationsQuickbooks,
  updateIntegrationsQuickbooks
} from "../../services/integrations";
import { useWSMutation } from "../helpers";
import {
  QUERY_INTEGRATIONS_QUICKBOOKS,
  QUERY_INTEGRATIONS_QUICKBOOKS_ACCOUNT_ASSETS,
  QUERY_INTEGRATIONS_QUICKBOOKS_ACCOUNT_EXPENSES,
  QUERY_INTEGRATIONS_QUICKBOOKS_VENDORS,
  QUERY_INTEGRATIONS_QUICKBOOKS_ITEMS,
  QUERY_INTEGRATIONS_QUICKBOOKS_CUSTOMERS,
  QUERY_INTEGRATIONS_QUICKBOOKS_ACCOUNT_LIABILITIES,
  QUERY_INTEGRATIONS_QUICKBOOKS_ACCOUNT_REVENUES
} from "./keys";

export const useMutationCreateIntegrationQuickbooks = () =>
  useWSMutation(
    (redirectUrl: string) => createIntegrationsQuickbooks({ redirectUrl }),
    {
      dependencies: [QUERY_INTEGRATIONS_QUICKBOOKS]
    }
  );

export const useMutationUpdateIntegrationQuickbooks = () =>
  useWSMutation(updateIntegrationsQuickbooks, {
    dependencies: [QUERY_INTEGRATIONS_QUICKBOOKS]
  });

export const useMutationDeleteIntegrationQuickbooks = () =>
  useWSMutation(deleteIntegrationsQuickbooks, {
    dependencies: [
      QUERY_INTEGRATIONS_QUICKBOOKS,
      QUERY_INTEGRATIONS_QUICKBOOKS_ACCOUNT_ASSETS,
      QUERY_INTEGRATIONS_QUICKBOOKS_ACCOUNT_EXPENSES,
      QUERY_INTEGRATIONS_QUICKBOOKS_VENDORS,
      QUERY_INTEGRATIONS_QUICKBOOKS_ITEMS,
      QUERY_INTEGRATIONS_QUICKBOOKS_CUSTOMERS
    ]
  });

export const useMutationCreateIntegrationsQuickbooksAccountAssets = () =>
  useWSMutation(createIntegrationsQuickbooksAccountAssets, {
    dependencies: [QUERY_INTEGRATIONS_QUICKBOOKS_ACCOUNT_ASSETS]
  });

export const useMutationCreateIntegrationsQuickbooksAccountExpenses = () =>
  useWSMutation(createIntegrationsQuickbooksAccountExpenses, {
    dependencies: [QUERY_INTEGRATIONS_QUICKBOOKS_ACCOUNT_EXPENSES]
  });

export const useMutationCreateIntegrationsQuickbooksAccountLiabilities = () =>
  useWSMutation(createIntegrationsQuickbooksAccountLiabilities, {
    dependencies: [QUERY_INTEGRATIONS_QUICKBOOKS_ACCOUNT_LIABILITIES]
  });

export const useMutationCreateIntegrationsQuickbooksAccountRevenues = () =>
  useWSMutation(createIntegrationsQuickbooksAccountRevenues, {
    dependencies: [QUERY_INTEGRATIONS_QUICKBOOKS_ACCOUNT_REVENUES]
  });

export const useMutationCreateIntegrationsQuickbooksCustomers = () =>
  useWSMutation(createIntegrationsQuickbooksCustomers, {
    dependencies: [QUERY_INTEGRATIONS_QUICKBOOKS_CUSTOMERS]
  });

export const useMutationCreateIntegrationsQuickbooksItems = () =>
  useWSMutation(createIntegrationsQuickbooksItems, {
    dependencies: [QUERY_INTEGRATIONS_QUICKBOOKS_ITEMS]
  });

export const useMutationCreateIntegrationsQuickbooksVendors = () =>
  useWSMutation(createIntegrationsQuickbooksVendors, {
    dependencies: [QUERY_INTEGRATIONS_QUICKBOOKS_VENDORS]
  });
